import '@uirouter/angularjs';
import angular from 'angular';

import { semaphore } from './semaphore.component';
import './semaphore.sass';

angular.module('tct.semaphore', [])
  .component('tctSemaphore', semaphore);
